import { DownOutlined } from "@ant-design/icons";
import { Flex, Select } from "antd";
import { CSSProperties, useState } from "react";
import { isIOS } from "react-device-detect";

const { Option } = Select;

const AppleDropdown = ({
    placeholder,
    options,
    handleChange,
    style,
    value,
    label,
    setValue,
}: {
    placeholder: string;
    options: any[];
    handleChange: (any: any) => void;
    style?: CSSProperties;
    value: string;
    label: string;
    setValue?: string;
}) => {
    const [hasValue, setHasValue] = useState(false);

    return (
        <Flex align="center" justify="center" style={{ position: "relative", ...style }}>
            <DownOutlined
                className="ant-select-arrow"
                style={{
                    pointerEvents: "none",
                    position: "absolute",
                    right: "15px",
                    width: "15px",
                    height: "20px",
                }}
            />
            <select
                value={setValue}
                onChange={(e) => {
                    handleChange(e.currentTarget.value);
                    setHasValue(true);
                }}
                className="date-select"
                style={{
                    width: "100%",
                    height: "50px",
                    fontSize: "13px",
                    textAlign: "left",
                    padding: "0 11px",
                    borderRadius: "12px",
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    backgroundColor: "transparent",
                    color: hasValue ? "rgba(0,0,0,1)" : "rgba(0,0,0,0.2)",
                    border: "1px solid rgba(0,0,0,0.2)",
                    cursor: "pointer",
                }}
            >
                <option value="" disabled selected>
                    {placeholder}
                </option>
                {options?.map((item) => {
                    return (
                        <option value={value === "" ? item : item[value]} key={item[value]}>
                            {item[label]}
                        </option>
                    );
                })}
            </select>
        </Flex>
    );
};

const Dropdown = ({
    placeholder,
    options,
    handleChange,
    style,
    value,
    label,
    setValue,
}: {
    placeholder: any;
    options: any[];
    handleChange: (any: any) => void;
    style?: CSSProperties;
    value: string;
    label: string;
    setValue?: string;
}) => {
    return (
        <Select
            value={setValue}
            {...{ style }}
            onChange={(e) => {
                handleChange(e);
            }}
            placeholder={placeholder}
            className="date-select"
        >
            {options?.map((item: any, index) => {
                return (
                    <Option value={value === "" ? item : item[value]} key={index}>
                        {item[label]}
                    </Option>
                );
            })}
        </Select>
    );
};

const DynamicDropdown = ({
    setValue,
    placeholder,
    options,
    handleChange,
    style,
    value,
    label,
}: {
    setValue?: string;
    placeholder: any;
    options: any[];
    handleChange: (any: any) => void;
    style?: CSSProperties;
    value: string;
    label: string;
}) => {
    return isIOS ? (
        <AppleDropdown
            {...{ style }}
            placeholder={placeholder}
            options={options}
            handleChange={handleChange}
            value={value}
            label={label}
            setValue={setValue}
        />
    ) : (
        <Dropdown
            {...{ style }}
            placeholder={placeholder}
            options={options}
            handleChange={handleChange}
            value={value}
            label={label}
            setValue={setValue}
        />
    );
};

export default DynamicDropdown;
